export default [
    {
        path: '/users',
        view: 'users/Index',
        name: 'Usuários',
        permissions: ['ADMINISTRADOR', 'GESTOR', 'AUDITOR'],
        breadcrumbs: [
            {
                text: 'Início',
                disabled: false,
                exact: true,
                to: '/dashboard',
            },
            {
                text: 'Usuários',
                disabled: true,
                exact: true,
                to: '/users',
            },
        ],
    },
]